import { useGetCategoryQuery } from "../store/api/directory/categoryApi"
import { useGetCountryQuery } from "../store/api/directory/countryApi";
import { useGetCurrencyQuery } from "../store/api/directory/currencyApi";
import { useGetRecieverQuery } from "../store/api/directory/recieverApi";
import { useGetRegionQuery } from "../store/api/directory/regionApi";
import { useGetCustomersQuery } from "../store/api/customerApi";
import { useGetWarehouseQuery } from "../store/api/directory/warehouse";
import { useEffect, useState } from "react";
import { useGetPartialByFilterMutation } from "../store/api/partialApi";
import { useGetTypesQuery } from "../store/api/directory/typeApi";
import { useGetRolesQuery } from "../store/api/directory/roleApi";
import { useGetStatusQuery } from "../store/api/directory/statusApi";
import { useGetPickupQuery } from "../store/api/directory/pickupApi";



export const useOrderColumns = (opt, def = {
    partial: {
        status: 0
    }
}) => {
    const [partials, setPartials] = useState([]);
    const { data: optionCategory = [] } = useGetCategoryQuery();
    const { data: optionCurrency = [] } = useGetCurrencyQuery();
    const { data: optionReciever = [] } = useGetRecieverQuery();
    const { data: optionRegion = [] } = useGetRegionQuery();
    const { data: optionCountry = [] } = useGetCountryQuery();
    const { data: users = [] } = useGetCustomersQuery()
    const { data: types = [] } = useGetTypesQuery()
    const { data: roles = [] } = useGetRolesQuery()
    const { data: warehouses } = useGetWarehouseQuery();
    const { data: statuses } = useGetStatusQuery();
    const { data: { pickup_list: pickups } = { pickup_list: [] } } = useGetPickupQuery();
    const [fetchByPost, { data, isLoading }] = useGetPartialByFilterMutation();

    const handleClick = async () => {
        const response = await fetchByPost({
            filters: {
                status: def.partial.status,
            },

        });
        setPartials(response.data);
    }
    useEffect(() => {
        handleClick()
    }, [def.partial.status])
    switch (opt) {
        case 1:
            return optionCategory;
        case 2:
            return optionCurrency;
        case 3:
            return optionReciever;
        case 4:
            return optionRegion;
        case 5:
            return optionCountry;
        case 6:
            return users?.data;
        case 7:
            return warehouses?.result;
        case 8:
            return partials;
        case 9:
            return types;
        case 10:
            return roles;
        case 11:
            return statuses;
        case 12:
            return pickups;
        default:
            return optionCategory
    }

}